export const environment = {
  production: false,
  type: 'qa',
  region: 'nam',
  config: {
    ECL_PLATFORM_URL: 'https://ecl-platform.maersk-digital.dev',
    TRACKING_SERVICE_URL: 'https://mectracking-configuration-qa-cdt.maersk.io',
    RUM_API_KEY: '',
    RUM_APP_NAME: 'MecTrackingUI-Qa',
  },
};
